<template>
  <footer class="footer">
    <div class="footer__top">
      <div class="footer__left">
        <nav class="footer__links footer__solutions" :aria-label="$t('solutionsMenu.label')">
          <span>{{$t('solutionsMenu.label')}}</span>
          <ul>
            <li v-for="solution in solutions" :key="solution.id">
              <a
                :href="solution.href"
                :class="{active: pageIsActive(solution.href)}"
                @click="trackSolution(solution)"
              >{{$t(solution.titleKey)}}</a>
            </li>
          </ul>
        </nav>
        <nav class="footer__links footer__products" :aria-label="$t('productsMenu.label')">
          <span>{{$t('productsMenu.label')}}</span>
          <ul>
            <li v-for="product in products" :key="product.id">
              <a :href="product.href" :class="{active: pageIsActive(product.href)}">{{$t(product.titleKey)}}</a>
            </li>
          </ul>
        </nav>
        <div class="footer__policy">
          <span>{{$t('footerPrivacy')}}</span>
          <ul>
            <li>
              <a href="/privacy" target="_blank">{{$t('footerPrivacy')}}</a>
            </li>
            <li>
              <a href="/website-terms" target="_blank">{{$t('footerWebsiteTerms')}}</a>
            </li>
            <li>
              <a href="/extension-terms" target="_blank">{{$t('footerExtensionTerms')}}</a>
            </li>
          </ul>
        </div>
      </div>
      <div class="footer__right">
        <span>{{$t('followUs')}}</span>
        <ul>
          <li>
            <a class="footer__l" target="_blank" href="https://www.linkedin.com/company/drct/" @click="clickOnSocial('in')"></a>
          </li>
          <li>
            <a class="footer__f" target="_blank" href="https://www.facebook.com/drct.aero/" @click="clickOnSocial('fb')"></a>
          </li>
      <!--    <li>
            <a class="footer__t" target="_blank" href="https://twitter.com/drctltd"></a>
          </li> -->
        </ul>
      </div>
    </div>
    <div class="footer__bottom">
      <div>
        <i>Copyright © 2017-{{new Date().getFullYear()}} DRCT Ltd, Ewropa Business Centre, Level 3-701, Dun Karm Street, Birkirkara, BKR9034, Malta</i>
      </div>
    </div>
  </footer>
</template>

<script>
import { AmplitudeEvent } from 'components/shared/amplitude.js';
import { productLinks } from './productLinks.js';
import { solutionLinks } from './solutionLinks.js';

export default {
  data(){
    return {
      products: productLinks,
      solutions: solutionLinks
    }
  },
  methods: {
    pageIsActive(pageUrl){
      const path = window.location.pathname
      if (path == pageUrl) {
        return true
      }
    },
    forAirlines(){
      new AmplitudeEvent("For airlines", { spot: "bottom" })
    },
    forAgencies(){
      new AmplitudeEvent("For agents", { spot: "bottom" })
    },
    trackSolution(solution){
      if (solution.analytics === 'airlines') {
        this.forAirlines()
      } else {
        this.forAgencies()
      }
    },
    clickOnSocial(name){
      new AmplitudeEvent("Social media", { sm: name })
    }
  }
}
</script>

<style lang="scss" scoped>
footer {
  position: absolute;
  left: 0;
  bottom: 0;
  width: 100%;
  height: 55px;
  background-color: rgba(27, 39, 51, .05);

  & > div {
    width: 1011px;
    margin: 0 auto;
    display: flex;
    justify-content: space-between;
    height: 55px;
  }

  i {
    opacity: 0.35;
    font-size: 11px;
    font-weight: bold;
    letter-spacing: 0.2px;
    color: rgb(27, 39, 51);
    text-transform: uppercase;
  }

  ul {
    display: flex;

    li {
      a {
        opacity: 0.35;
        font-size: 11px;
        font-weight: bold;
        letter-spacing: 0.2px;
        color: rgb(27, 39, 51);
        margin-left: 20px;
        text-decoration: none;
        text-transform: uppercase;

        // &:hover, &:active {
        //   opacity: .6;
        // }
      }
    }
  }
}

.footer {
  position: relative;
  margin-top: 60px;
  background: white;
  border-top: 1px solid rgba(27, 39, 51, .1);

  i {
    text-transform: none;
  }
}

.footer__links {
  min-width: 0;

  @media (max-width: 767px) {
    margin-bottom: 24px;
  }

  ul {
    display: flex;
    flex-direction: column;

    li {
      margin-bottom: 4px;
    }
  }

  & > span {
    font-size: 13px;
    font-weight: bold;
    text-align: right;
    color: rgb(27, 39, 51);
    margin-bottom: 8px;
    display: inline-block;
  }

  a {
    cursor: pointer;
    text-transform: uppercase;
    opacity: .5;
    font-size: 13px;
    font-weight: bold;
    color: rgb(27, 39, 51);
    margin-left: 0;
    transition: opacity .2s;

    &:hover, &:active {
      opacity: .8;
    }
  }
}

.footer__left {
  display: flex;
  gap: clamp(32px, 5vw, 72px);
  min-width: 0;

  @media (max-width: 767px) {
    flex-direction: column;
    gap: 0;
  }
}

.footer__right {
  & > span {
    font-size: 13px;
    font-weight: bold;
    text-align: right;
    color: rgb(27, 39, 51);
    margin-bottom: 8px;
    display: inline-block;
  }

  ul {
    li:first-child {
      margin-left: 0;
    }

    li {
      width: 44px;
      height: 44px;
      margin-left: 10px;
      position: relative;

      a {
        width: 16px;
        height: 16px;
        display: inline-block;
        position: absolute;
        top: 0;
        bottom: 0;
        left: 0;
        right: 0;
        margin: auto;
        background-repeat: no-repeat;
        background-position: center;
        padding: 22px;
        background-color: rgba(27, 39, 51, .05);
        border-radius: 10px;
        opacity: 1;
      }

      .footer__l {
        background-image: url("../images/landing/li_b.svg");
        &:hover, &:active {
          background-color: #0077b5;
          background-image: url("../images/landing/li_w.svg");
        }
      }

      .footer__f {
        background-image: url("../images/landing/fb_b.svg");
        &:hover, &:active {
          background-color: #4267b2;
          background-image: url("../images/landing/fb_w.svg");
        }
      }

      .footer__t {
        background-image: url("../images/landing/tw_b.svg");
        &:hover, &:active {
          background-color: #1da1f2;
          background-image: url("../images/landing/tw_w.svg");
        }
      }
    }
  }
}

.footer__policy {
  min-width: 0;

  ul {
    display: flex;
    flex-direction: column;

    li {
      margin-bottom: 4px;
    }
  }

  & > span {
    font-size: 13px;
    font-weight: bold;
    text-align: right;
    color: rgb(27, 39, 51);
    margin-bottom: 8px;
    display: inline-block;
  }

  ul {
    li {
      a {
        margin-left: 0;
        cursor: pointer;
        text-transform: uppercase;
        opacity: .5;
        font-size: 13px;
        font-weight: bold;
        color: rgb(27, 39, 51);
        margin-left: 0;
        transition: opacity .2s;

        &:hover, &:active {
          opacity: .8;
        }
      }
    }
  }

  @media (max-width: 767px) {
    margin-bottom: 24px;
  }
}

.footer__top {
  padding: 30px 0 40px;
  display: flex;
  gap: 32px;
  justify-content: space-between;
  height: auto;

  @media (max-width: 1024px) {
    padding-left: 10px;
    padding-right: 10px;
    width: 100%;
  }

  @media (max-width: 767px) {
    display: flex;
    flex-direction: column;
    align-items: baseline;
    gap: 0;
    padding: 32px 16px;
  }

  @media (min-width: 768px) and (max-width: 900px) {
    flex-wrap: wrap;

    .footer__right {
      margin-left: auto;
    }
  }

  @media (max-width: 413px) {
    padding: 32px 10px;
  }
}

.footer__bottom {
  background-color: #f4f4f5;
  width: 100%;
  height: 77px;
  line-height: 18px;
  padding-bottom: 16px;
  padding-top: 16px;

  > div {
    width: 1011px;
    margin: 0 auto;

    @media (max-width: 1024px) {
      width: 100%;
      padding: 0 10px;
    }
  }

  @media (max-width: 767px) {
    padding-bottom: 16px;
    padding-top: 16px;
    height: auto;
  }
}
</style>
